import { useNavigate } from "react-router-dom";
import { Button } from "@/components/ui/button";
import { ArrowLeft, ShieldCheck } from "lucide-react";
import { EnterpriseInferenceConsole } from "@/components/EnterpriseInferenceConsole";

// Customer/tenant-facing Enterprise Inference console. The console self-gates
// every action by the caller's enterprise permissions, so a tenant admin sees
// (and can approve/revoke) support access + the active-access banner, while a
// platform engineer additionally sees the support REQUEST form. This is what
// makes customer approval + visible indication reachable outside /platform-admin.
export default function EnterpriseConsolePage() {
  const navigate = useNavigate();
  return (
    <div className="min-h-screen bg-slate-950 text-slate-100" data-testid="enterprise-page">
      <div className="border-b border-slate-800 bg-slate-900/60 backdrop-blur">
        <div className="max-w-7xl mx-auto px-6 py-4 flex items-center gap-3">
          <Button variant="ghost" size="sm" onClick={() => navigate("/dashboard")} data-testid="enterprise-back-btn">
            <ArrowLeft className="w-4 h-4 mr-1" /> Dashboard
          </Button>
          <div className="flex items-center gap-2 text-slate-200 font-semibold">
            <ShieldCheck className="w-5 h-5 text-emerald-400" /> Enterprise Inference
          </div>
        </div>
      </div>
      <div className="max-w-7xl mx-auto px-6 py-6">
        <EnterpriseInferenceConsole />
      </div>
    </div>
  );
}
